export default {"src":"/_next/static/media/gray-checklist.68b33c6b.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};